import FullLoader from "components/loader/full-loader";
import InvoicePreview from "./components/invoice-preview";
import { useInvoiceView } from "contexts/v1/pages/InvoiceViewContext";

const InvoicePublicViewPage = () => {
    const { invoice } = useInvoiceView();

    if (invoice.loading) {
        return (<FullLoader />);
    }

    return (
        <div className="container py-4">
            <InvoicePreview invoice={invoice} className={"a4-size"} />
        </div>
    );
};

export default InvoicePublicViewPage;